import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { citySelector } from 'slices/citySlice'
export function toCapitalize(val) {
    return (
        <span className='text-capitalize'>
            {val}
        </span>
    )
}

const ViewRequestTable = React.memo(({ item, isRequestView }) => {

    console.log('item', item)

    const fields = [
        { label: "US Based Vendor", name: "us_based", isLocked: 0 },
        { label: "Non US Based Vendor", name: "non_us_based", isLocked: 0 },
        { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
        { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
        { label: "Court Certified", name: "court_certified", isLocked: 0 },
        { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ];


    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    // const cityName = React.useMemo(() => {
    //     const cityName = cities?.find(city => city.id === item?.facility?.city_id)?.name;
    //     return cityName || "N/A";
    // }, [item?.facility?.city_id])

    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = item?.appointment_details?.dynamic_fields && JSON.parse(item?.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [item?.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text,) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || 'N/A'}</td>
        </>

    )

    // const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    // console.log('dynamicFields',dynamicFields[0].name == null)
    return (

        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                <div className="card_table" style={marginTopZero}>

                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Facility: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.facility?.facility_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Department: </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.department?.department_name || 'N/A'}</td>
                                </tr>
                                {item?.type === 'In Person' && (
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Address:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.address || item.appointment_details?.facility?.street_address}</td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                                    <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div> */}
                    

                </div>
                <div className="card_table" style={marginTopZero}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                            <tbody>
                                <tr>
                                    <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>Status: </td>
                                    <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status == 'cancelled' ? item?.request_details?.cancelled_by === 'mb' ? 'Cancelled by MB' : 'Cancelled' : item?.status}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan  || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}


                    {/* <div className="Table_data_show Table_data_show1 pt-0">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                {fields.map((field, index) => (
                                    <tr key={index}>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>
                                            {field.label}
                                        </td>
                                        <td className="bg-primary-secondary">
                                            {item?.appointment_details?.[field.name] === 1
                                                ? "Yes"
                                                : item?.appointment_details?.[field.name] === 0
                                                    ? "No"
                                                    : "N/A"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </div>

            <div className="Table_data_show Table_data_show1 pt-0 ">
                <table class="bg-primary-secondary table">
                    <tbody>
                        <tr>
                            <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Name: </td>
                            <td class="bg-primary-secondary">{item.appointment_details?.requester_name || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Email: </td>
                            <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td class="bg-primary-secondary" style={{ width: "40%" }}>Requester Phone:</td>
                            <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || 'N/A'}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "20%" }}>Estimated Duration: </td>
                                <td class="bg-primary-secondary" >{item?.estimated_duration || 'N/A'} {item?.estimated_duration_unit || 'N/A'} </td>
                                {item?.status === 'cancelled' && (
                                    <>
                                        <td class="bg-primary-secondary" style={{ width: "20%" }}>Cancel Reason: </td>
                                        <td class="bg-primary-secondary" >{item?.request_details?.cancel_reason || 'N/A'} </td>
                                    </>
                                )}
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
                  {/* { ( dynamicFields.length > 0 && dynamicFields[0]?.name !== null)  &&    
                <div className="row_dash_1" style={rowDash2Style}>
                    <div className="Table_data_show Table_data_show1 pt-0">

                        <table className="bg-primary-secondary table">
                            {item?.id &&
                                <tbody>
                                    <tr >
                                        {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                             renderTableItem(`Dynamic Field ${index + 1}`, `${field.name}: ${field.value || 'N/A' }`)
                                        ))}
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
                }            */}
          


            {item?.type !== "Telephonic" && item?.appointment_custom_pricing && (
                <>
                    <div className="interpreter p-4">
                        <h2>Custom Appointment Pricing:</h2>
                    </div>

                    <div className="row_dash_1" style={rowDash2Style}>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary">Mileage (km):</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.mileage ?? '0'}</td>
                                        <td className="bg-primary-secondary">Mileage Rate:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.mileage_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">Mileage Total:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.mileage_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">Travel Hours:</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.travel_hours ?? '0'}</td>
                                        <td className="bg-primary-secondary">Travel Rate:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.travel_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">Travel Total:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.travel_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">Min Duration (hrs):</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.min_duration ?? '0'}</td>
                                        <td className="bg-primary-secondary">Rate per hr:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.duration_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">Session Total:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.session_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Subtotal:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.sub_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Discount (%):</td>
                                        <td className="bg-primary-secondary">
                                            {(item.appointment_custom_pricing?.discount ?? 0) + '%'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>Appointment Total:</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.appointment_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </>
            )}



            {/* <div className="profile-section">
                <h2>Basic Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Appointment ID:" value={item?.appid} />
                    <InfoRow label="Status:" value={item?.status} />
                    <InfoRow label="Date:" value={item?.date} />
                    <InfoRow label="Time:" value={item?.start_time} />
                    <InfoRow label="Appointment Type:" value={item?.type} />
                    <InfoRow label="Language:" value={item?.language?.name} />
                    <InfoRow label="Facility:" value={item?.appointment_details?.facility?.abbreviation} />
                    <InfoRow label="Department:" value={item?.appointment_details?.department?.department_name} />
                    <InfoRow label="Estimated Duration:" value={`${item.duration} minutes`} />
                    <InfoRow label="Facility Address:" value={item.appointment_details?.facility?.address} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Client Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Client Name:" value={item?.accounts?.user?.name} />
                    <InfoRow label="Client Email:" value={item?.accounts?.user?.email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Client Phone:" value={item?.accounts?.phone} />
                </div>
            </div> */}
            {/* {(item?.interpreter || item?.vendor) &&
                <div className="profile-section">
                    <h2>Interpreter / Vendor</h2>
                    <div className='row_sec_wrapper'>
                        {item?.interpreter &&
                            <>
                                {item?.interpreter?.vendor ?
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name} />
                                    :
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name} />
                                }
                                <InfoRow label="Interpreter Email:" value={item?.interpreter?.user?.email} toLowerCase={'text-lowercase'} />
                                <InfoRow label="Interpreter Phone:" value={item?.interpreter?.phone} />
                            </>
                        }
                        {item?.vendor &&
                            <>
                                <InfoRow label="Vendor Name:" value={item?.vendor?.name} />
                                <InfoRow label="Vendor Email:" value={item?.vendor?.email} toLowerCase={'text-lowercase'} />
                            </>
                        }
                    </div>
                </div>
            } */}

            {/* <div className="profile-section">
                <h2>Patient Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Patient Name:" value={item.appointment_details?.patient?.patient_name} />
                    <InfoRow label="Patient Phone:" value={item.appointment_details?.patient_phone} />
                    <InfoRow label="Patient Birthdate:" value={item.appointment_details?.patient?.birth_date} />
                    <InfoRow label="MRN Number:" value={item.appointment_details?.patient?.mrn_number} />
                    <InfoRow label="Medicaid Id:" value={item.appointment_details?.patient?.medicaid_id} />
                    <InfoRow label="Medicaid Plan:" value={item.appointment_details?.patient?.medicaid_plan} />
                </div>
            </div> */}

            {/* <div className="profile-section">
                <h2>Requestor Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Requester Name:" value={item.appointment_details?.requester_name} />
                    <InfoRow label="Requester Email:" value={item.appointment_details?.requester_email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Requester Phone:" value={item.appointment_details?.requester_phone} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Appointment Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Priority Level:" value={item.appointment_details?.priority_level} />
                    <InfoRow label="Provider Name:" value={item.appointment_details?.provider_name} />
                    <InfoRow label="Special Instruction:" value={item.appointment_details?.special_instruction} />
                    <InfoRow label="Encounter Source:" value={item.appointment_details?.encounter_source} />
                    <InfoRow label="Reschedule reason:" value={item?.appointment_details?.reschedule_reason} />
                    <InfoRow label="CNC reason:" value={item?.appointment_details?.cnc_reason} />
                    <InfoRow label="DNC reason:" value={item?.appointment_details?.dnc_reason} />
                    <InfoRow label="Cancel reason:" value={item?.appointment_details?.cancel_reason} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Checkin/Checkout Deatils</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Checkin Date:" value={item.appointment_assign?.checkin_date} />
                    <InfoRow label="Checkin Time:" value={item.appointment_assign?.checkin_time} />
                    <InfoRow label="Checkout Date:" value={item.appointment_assign?.checkout_date} />
                    <InfoRow label="Checkout Time:" value={item.appointment_assign?.checkout_time} />
                    <InfoRow label="Comments:" value={item.appointment_assign?.comments} />
                    <InfoRow label="Notes:" value={item.appointment_assign?.notes} />
                </div>
            </div> */}
        </div>
    )

})

export default ViewRequestTable
